import React, { PureComponent } from 'react'
import {
  Grid,
  TableRow,
  Table,
  TableHead,
  TableCell,
  Paper,
  Button,
  TableBody,
  ListItem,
  FormLabel,
} from '@material-ui/core'
import Checkbox from '@material-ui/core/Checkbox/Checkbox'
export default class QuickBookList extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      desktopFields: [],
      selectAll: true,
      activeAllTab: false,
    }
  }

  componentWillMount() {
    const arrayData = []
    this.props.data &&
      this.props.data.forEach((res) =>
        res.qbDesktopFields.forEach((res) => {
          arrayData.push(res)
        }),
      )
    this.setState({
      desktopFields: arrayData,
    })
    this.props.data &&
      this.props.data.forEach((res) =>
        res.qbDesktopFields.forEach((res) => {
          if (!res.enabled && !res.required) {
            this.setState({
              selectAll: false,
            })
          }
        }),
      )
  }

  handleChange = (id, index) => (event) => {
    this.setState({
      selectAll: true,
    })
    const desktopFields = this.state.desktopFields
    desktopFields[index].enabled = !desktopFields[index].enabled
    this.setState({
      desktopFields: desktopFields,
    })
    this.props.data &&
      this.props.data.map((res) =>
        res.qbDesktopFields.map((res) => {
          // eslint-disable-line
          if (!res.enabled && !res.required) {
            this.setState({
              selectAll: false,
            })
          }
        }),
      )
    this.forceUpdate()
  }

  onSave = () => {
    this.props.onSave()
  }

  onReSync = () => {
    const reSyncData = {
      operationId: this.props.data[0].operationId,
      status: false,
    }
    this.props.onReSync(reSyncData)
  }

  selectAll = (key) => (e) => {
    const desktopFields = this.state.desktopFields

    this.setState({
      selectAll: !this.state.selectAll,
    })
    this.props.data &&
      this.props.data
        .map((value) => value.qbDesktopFields)
        .map((each) => {
          // eslint-disable-line
          each.map((item, index) => {
            // eslint-disable-line
            if (!item.required) {
              desktopFields[index].enabled = !this.state.selectAll
            }
          })
        })
    this.setState({
      desktopFields: desktopFields,
    })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      selectAll: true,
    })
    var arrayData = []
    if (nextProps != this.state) {
      // eslint-disable-line
      nextProps.data &&
        nextProps.data.forEach((res) =>
          res.qbDesktopFields.forEach((res) => {
            if (!res.enabled && !res.required) {
              this.setState({
                selectAll: false,
              })
            }
            arrayData.push(res)
          }),
        )
      this.setState({
        desktopFields: arrayData,
      })
    }
  }

  enableAll = () => {
    const arrayData = []
    this.props.allSelectData &&
      this.props.allSelectData.forEach((res) =>
        res.qbDesktopFields.forEach((res) => {
          arrayData.push(res)
        }),
      )
    this.setState(
      {
        desktopFields: arrayData,
      },
      () => {
        const desktopFields = this.state.desktopFields
        this.setState({
          selectAll: !this.state.selectAll,
        })
        this.props.allSelectData &&
          this.props.allSelectData.forEach((value) => {
            value.qbDesktopFields.forEach((item) => {
              desktopFields.forEach((val, index) => {
                if (!val.required) {
                  desktopFields[index].enabled = !this.state.selectAll
                }
              })
            })
          })
        this.setState({
          desktopFields: desktopFields,
        })
      },
    )
  }

  render() {
    var propsData =
      this.props.data && this.props.data.length > 0 && this.props.data[0].qbDesktopFields
    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-xs">
            <div className="table-scroll">
              <Button onClick={this.onSave} className="primary-button margin pull-right">
                Save Fields
              </Button>
              <Button onClick={this.enableAll} className="primary-button margin  pull-right">
                Enable All
              </Button>
              {this.props.data[0].syncPaused ? (
                <Button onClick={this.onReSync} className="primary-button margin pull-right">
                  Enable Sync
                </Button>
              ) : null}
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-xs">
            <div className="table-scroll">
              {propsData && propsData.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Field Name</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>
                        Enable All
                        <Checkbox
                          checked={this.state.selectAll}
                          onChange={this.selectAll('required')}
                        />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {propsData &&
                      propsData.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            {item.name}
                            {item.required ? '*' : null}
                          </TableCell>
                          <TableCell>{item.description}</TableCell>
                          <TableCell>
                            <Checkbox
                              disabled={item.required}
                              checked={item.enabled}
                              onChange={this.handleChange(item.fieldKey, index)}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              ) : (
                <ListItem>
                  <FormLabel component="legend">Data not available</FormLabel>
                </ListItem>
              )}
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/QuickBook/QuickBookList.js